/**
 *
 * @module purchaseType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PurchaseType
 * @type {Object}
 * @desc Defines the different types of purchases that are supported.
 * @example PurchaseType.AppleIAP // 'AppleIAP'
 *
 * @property {String} AppleIAP - Apple in app purchase.
 * @property {String} GoogleIAP
 * @property {String} DirectToConsumer - Direct to consumer purchase.
 *
 */

/**
 *
 * @enum
 * @type {PurchaseType}
 *
 */
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    AppleIAP: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    GoogleIAP: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    DirectToConsumer: null
});



// WEBPACK FOOTER //
// ./src/purchase/purchaseType.js